// Ready dates follow the store's clock (store config autoCloseTimezone, the
// zone the BE uses for the store too), not the POS machine's own time zone.
let storeTimeZone: string | undefined;

export const setStoreTimeZone = (timeZone?: string | null) => {
  storeTimeZone = timeZone || undefined;
};

/**
 * The current time as a local Date showing the store's wall-clock time
 * (date, hours, minutes), so date maths on it lands on the store's days.
 * Falls back to the machine clock when no valid zone is known.
 */
export const storeNow = (now: Date = new Date()): Date => {
  if (!storeTimeZone) return new Date(now);
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: storeTimeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }).formatToParts(now);
    const get = (type: string) =>
      Number(parts.find((p) => p.type === type)?.value);
    return new Date(
      get("year"),
      get("month") - 1,
      get("day"),
      get("hour"),
      get("minute"),
      get("second")
    );
  } catch {
    return new Date(now);
  }
};
